//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('vatReport', {
//        templateUrl: 'views/components/views/vatReport/vatReport.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'vatReportService', function ($stateParams, stateService, utilityService, modalService, translateService, vatReportService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let businessCoNo = $stateParams.businessco_no;
//            let accountingYear = $stateParams.accounting_year;
//            let vatReportKeyno = $stateParams.vatreport_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListTaxPeriods: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await vatReportService.getEdit({
//                    businessco_no: businessCoNo,
//                    accounting_year: accountingYear,
//                    vatreport_keyno: vatReportKeyno
//                }))[0];
//            }

//            async function loadTaxPeriods() {
//                if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.accounting_year) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.vatreport_keyno) !== true) return;

//                return vm.model.selectListTaxPeriods = await vatReportService.listTaxPeriods({
//                    businessco_no: vm.model.edit.businessco_no,
//                    accounting_year: vm.model.edit.accounting_year,
//                    vatreport_keyno: vm.model.edit.vatreport_keyno
//                });
//            }
            
//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                vatReportService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//            	await loadEdit();
//                loadTaxPeriods();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
